
const { HttpClient } = require("../common/axios/HttpClient")


const ManagePackageService = {
    async login(body) {
        return await HttpClient.post(`/api/ManageAccounts/admin/login`, body)
    },
    async searchAccount(params) {
        return await HttpClient.get(`/api/ManageAccounts/account/search`, { params: params })
    },
    async searchMember(params) {
        return await HttpClient.get(`/api/ManageAccounts/member/search`, { params: params })
    },
    async searchUserPackage(params) {
        return await HttpClient.get(`/api/ManageAccounts/UserPackage/search`, { params: params })
    },
    async topupPackage(body) {
        return await HttpClient.post(`/api/ManageAccounts/package/topUp`, body)
    },


    

    // http://localhost:44342/api/ManageAccounts/member/search?province=%E0%B8%95%E0%B8%A3%E0%B8%B1%E0%B8%87&page=1&pageSize=10
}

export default ManagePackageService;